import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router";
import "../../assets/css/style.css";
import "../../assets/css/login.css";
import { ApiHelper } from "../../helpers/ApiHelper";
import { API } from "../../services/api";
import { getUserDetails } from "../../services/apiProfile";
import "../../assets/css/style_new.css";
import coverimg from "../../assets/img/profile/default-cover.svg"
import profileimg from "../../assets/img/profile/profile-img.svg"
import eye from "../../assets/img/profile/eye.svg"
import eye2 from "../../assets/img/profile/eyesingle.svg"
import edit from "../../assets/img/profile/edit.svg"
import community1 from "../../assets/img/profile/community1.svg"
import plus from "../../assets/img/profile/pluswhite.svg"
import mapin from "../../assets/img/profile/map-pin.svg"
import search from "../../assets/img/profile/search.svg"
import event from "../../assets/img/profile/event-img.png"
import Favoritesimg from "../../assets/img/fovr-img.svg"
import videoimg from "../../assets/img/video-img.svg"
import playimg from "../../assets/img/play-circles.svg"
import leftarrow from "../../assets/img/left-sider.svg"
import rightarrow from "../../assets/img/right-sider.svg"
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Form from 'react-bootstrap/Form';
import quest from "../../assets/img/profile/questions.svg"
import ProfileBio from "./ProfileBio";
import ProfileCommunity from "./ProfileCommunity";
import Spinner from "../../commonComponents/Spinner";
import UpcomingEvents from "./UpcomingEvents";
import SavedPost from "./SavedPost";
import Favorites from "./Favourites";
import MyPost from "./Mypost";
import ProfileQuestion from "../ProfileQuestion/ProfileQuestion";
import ProfilePost from "./ProfileMypost";



const ProfilePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state || {};
  const [age, setAge] = useState('');
  const [userArr, setUserArr] = useState([]);
  const [postArr, setPostArr] = useState([]);
  const [isBio, setIsBio] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isCommunity, setIsCommunity] = useState(false);
  const [activeTab, setActiveTab] = useState( localStorage.getItem('profileTab') ? localStorage.getItem('profileTab') : "MyPosts" );
  const [limit, setLimit] = useState('');
  const [offset, setOffset] = useState('');
  const handleBioClose = () => setIsBio(false);
  const handleCommunityClose = () => setIsCommunity(false);
  const maxChars = 60;
  const profileToTabEventKey = {
    1: 'MyPosts',
    2: 'UpcomingEvents',
    3: 'Saved',
    4: 'Favorites',
  };
  const user = JSON.parse(localStorage.getItem('userData'));
  useEffect(() => {

    if (user) {
      fetchUserDetails(user._id, 10, 0);
    }
  }, [user._id])
  const fetchUserDetails = async (id, limit, offset) => {
    setLoader(true)
    const formData = {
      userid: user._id,
      offset: offset ? offset : 0,
      limit: limit ? limit : 10
    }
    let listTopics = await getUserDetails(formData);
    setUserArr(listTopics)
    setPostArr(listTopics.posts)
    setLoader(false)

    if (listTopics.user?.dob) {
      ageCalculator(listTopics.user?.dob)
    }

  };
  const handleTabSelect = (eventKey) => {
    setActiveTab(eventKey);
     localStorage.setItem("profileTab",(eventKey));
    switch (eventKey) {
      case 'MyPosts':
        if (user) {
          fetchUserDetails(user._id, 10, 0);
        }
        break;
      case 'UpcomingEvents':
        break;
      case 'Saved':
        if (user) {
          fetchUserDetails(user._id, 10, 0);
        }
        break;
      case 'Favorites':
        fetchUserDetails(user._id, 50, 0);
        break;
      default:
        break;
    }
  };
  
  const ageCalculator = (birthdate) => {
    const today = new Date();
    const birthDate = new Date(birthdate);
    let calculatedAge = today.getFullYear() - birthDate.getFullYear();
    if (
      today.getMonth() < birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())
    ) {
      calculatedAge--;
    }

    setAge(calculatedAge)
    return calculatedAge
  }
  return (

    <div >
      {loader && <Spinner />}
      <div className="main">
        <div className="contents">
          <div className="profile_user">
            <div className="coverimage">
              <img src={
                userArr?.user?.coverImage?.url
                  ? API.uploadFilePath + userArr.user.coverImage?.url
                  : profileimg
              } alt="test" className="cover_profile" />
              <div className="overlay"></div>
            </div>
            <div className="profile_main d-flex align-items-start">
              <div className="profile_avatar">
                <img src={
                  userArr?.user?.profileImage?.url
                    ? API.uploadFilePath + userArr.user.profileImage?.url
                    : profileimg
                } alt="test" className="cover_profile" />
              </div>
              <div className="profile_details flex-fill">
                <div className="avatarname_full d-flex-c">
                  <h3>{userArr?.user?.firstName + " " + userArr?.user?.lastName}</h3>
                  <Link className="profile_edit" to='/edit-profile'>
                    <img src={edit} alt="test" className="p-icon" />
                    Edit Profile</Link>
                </div>
                <div className="avatar_other-details d-flex-c align-items-stretch">

                  <div className="details_itms">
                    <h4>Bio</h4>
                    <p>{userArr.user?.bio?.slice(0, maxChars)}
                      {userArr.user?.bio?.length > maxChars && <Link className="profile_edit" onClick={() => setIsBio(true)} >View more</Link>}
                    </p>
                  </div>

                  <div className="details_itms">
                    <h4>About me</h4>
                    <ul>
                      <li>
                        <b>Age</b><span>{age}</span>
                      </li>
                      {userArr?.user?.location !== "" && <li>
                        <b>Location</b><span> {userArr?.user?.location}</span>
                      </li>}
                      {userArr?.user?.gender !== "" &&
                        <li>
                          <b>Gender</b><span>{userArr?.user?.gender}</span>
                        </li>}
                    </ul>
                  </div>

                  <div className="details_itms communities">
                    <h4>Communities</h4>
                    <ul className="profile_community d-flex flex-wrap" >
                      {userArr?.communities?.length > 3 ?
                        userArr.communities.slice(0, 2).map((community, index) => (
                          <li key={community._id}>
                            <img src={
                              community?.communityId?.profileImage?.url
                                ? API.uploadFilePath + community.communityId.profileImage.url
                                : profileimg
                            } alt="test" className="community_thumb" />
                            <span>{community.communityId.communityName} </span>
                          </li>)) :
                        userArr?.communities?.length === 1 ?
                          userArr?.communities?.map((community, index) => (
                            <li key={community._id} className="full-width">
                              <img src={
                                community?.communityId?.profileImage?.url
                                  ? API.uploadFilePath + community.communityId.profileImage.url
                                  : profileimg
                              } alt="test" className="community_thumb" />
                              <span>{community.communityId.communityName}</span>
                            </li>)) :
                          userArr?.communities?.map((community, index) => (
                            <li key={community._id}>
                              <img src={
                                community?.communityId?.profileImage?.url
                                  ? API.uploadFilePath + community.communityId.profileImage.url
                                  : profileimg
                              } alt="test" className="community_thumb" />
                              <span>{community.communityId.communityName}</span>
                            </li>))}

                      {userArr?.communities?.length > 3 &&
                        <li>
                          <Link href="#" className="viewall" onClick={() => setIsCommunity(true)}>
                            <img src={eye} alt="test" className="community_thumb" />
                            <span>View all </span>
                          </Link>
                        </li>}
                    </ul>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <Tabs activeKey={activeTab} id="fill-tab-example" className="mt-5 profile_tabs" fill onSelect={handleTabSelect}>

            <Tab eventKey="MyPosts" className="profile-tab-contents mt-4" title="My Posts">
              <ProfilePost  User={userArr} fetchUserDetails={fetchUserDetails} />
            </Tab>
            <Tab eventKey="UpcomingEvents" className="profile-tab-contents mt-4" title="Events">
              <UpcomingEvents type="profile" />
            </Tab>


            <Tab eventKey="Saved" className="profile-tab-contents mt-4" title="Saved">
              <SavedPost />
            </Tab>


            <Tab eventKey="Favorites" className="profile-tab-contents mt-4" title="Favorites">
              <Favorites Favorite={userArr.favouriteMembers} user={user._id} getUser={fetchUserDetails} />
            </Tab>
          </Tabs>
        </div>
        <ProfileQuestion type="profile" />

      </div>
      {isBio ? <ProfileBio isBio={isBio} handleClose={handleBioClose} name={userArr?.user?.userType === "individual" ? userArr?.user?.firstName + " " + userArr?.user?.lastName : userArr?.user?.firstName} content={userArr?.user?.bio} /> : null}
      {isCommunity ? <ProfileCommunity isCommunity={isCommunity} handleClose={handleCommunityClose} community={userArr?.communities} /> : null}
    </div>
  );

};
export default ProfilePage;
